import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {ReportAction} from '../Actions/Models/ReportActionModel';
import {Types} from 'Modules/ReportModule';

export type State = Types.ReportStore;
export const initialState: State = {
    carMainReport: null,
    carParkingReport: null,
    carRidesReport: null,
    terminalInstallationReport: null,
    latestUrlParams: null,
    vehiclesStateReportLatestUrlParams: null,
    activeTerminalsReport: null,
    vehiclesStateReport: null,
    allVehiclesStateReports: []
};

export function reportReducer(state: State = initialState, action: ReportAction): State {
    switch (action.type) {
        case ActionTypes.REPORT.GET_CAR_MAIN_REPORT:
            return {
                ...state,
                carMainReport: action.payload.carMainReport,
                latestUrlParams: action.payload.latestUrlParams
            };
        case ActionTypes.REPORT.GET_CAR_PARKING_REPORT:
            return {
                ...state,
                carParkingReport: action.payload.carParkingReport,
                latestUrlParams: action.payload.latestUrlParams
            };
        case ActionTypes.REPORT.GET_CAR_RIDES_REPORT:
            return {
                ...state,
                carRidesReport: action.payload.carRidesReport,
                latestUrlParams: action.payload.latestUrlParams
            };
        case ActionTypes.REPORT.GET_TERMINAL_INSTALLATION_REPORT:
            return {
                ...state,
                terminalInstallationReport: action.payload.terminalInstallationReport,
                latestUrlParams: action.payload.latestUrlParams
            };
        case ActionTypes.REPORT.GET_ACTIVE_TERMINALS_REPORT:
            return {
                ...state,
                activeTerminalsReport: action.payload.activeTerminalsReport,
                latestUrlParams: action.payload.latestUrlParams
            };
        case ActionTypes.REPORT.GET_VEHICLES_STATE_REPORT:
            return {
                ...state,
                vehiclesStateReport: action.payload.vehiclesStateReport,
                allVehiclesStateReports: action.payload.allVehiclesStateReports,
                vehiclesStateReportLatestUrlParams: action.payload.vehiclesStateReportLatestUrlParams
            };
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/ReportReducer.ts